(() => {
  if (window.bgmCompactCartBound) return;
  window.bgmCompactCartBound = true;
  const states = new WeakMap();
  const selector = 'details.bgm-progress-group--secondary';
  const bind = () => {
    document.querySelectorAll('.bgm-cart-compact cart-items').forEach(root => {
      if (states.has(root)) return;
      const state = { expanded: root.querySelector(selector)?.open || false };
      states.set(root, state);
      root.addEventListener('toggle', event => {
        if (event.target.matches(selector) && event.target.isConnected) state.expanded = event.target.open;
      }, true);
      const observer = new MutationObserver(() => {
        const details = root.querySelector(selector);
        if (details && details.open !== state.expanded) details.open = state.expanded;
      });
      observer.observe(root, { childList: true });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind, { once: true });
  else bind();
  document.addEventListener('shopify:section:load', bind);
})();
